import {
  toggleNavigationDrawer,
} from 'containers/App/App/actions'
import {
  updateTabIndex,
} from 'containers/App/AppNavigation/actions'

export const toggleDrawer = (tabIndex) => {
  return dispatch => {
    dispatch(updateTabIndex(tabIndex))
    dispatch(toggleNavigationDrawer())
  }
}
